import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import AlertBox from "../../component/AlertBox";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FaSuitcase, FaGraduationCap, FaCode } from "react-icons/fa6";
import { MdOutlineWatchLater } from "react-icons/md";
import { FaCalendar } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { IoDocumentText } from "react-icons/io5";
import ButtonCompo from "../../component/ButtonCompo";
import { FaUserPlus } from "react-icons/fa";
import DialogBox from "../../component/DialogBox";
import InputField from "../../component/InputField";
import SelectField from "../../component/SelectField";
import PaginationBar from "../../component/PaginationBar";

export function HiringReqData({ hiringReqData }) {
  return (
    <div className="rounded-lg shadow-lg">
      <div className="flex bg-blue-50/80 rounded-t-lg justify-between items-center p-5">
        <section>
          <h1 className="text-[25px] font-medium text-left w-full">
            {hiringReqData?.position}
          </h1>
          <p className="text-slate-700 mt-1">{hiringReqData?.role}</p>
        </section>
        <section className="flex gap-5 items-center">
          {hiringReqData?.status === "Open" ? (
            <section className="bg-blue-100 py-1 px-5 w-fit rounded-full text-blue-600 font-medium text-center">
              Open
            </section>
          ) : hiringReqData?.status === "In Progress" ? (
            <section className="bg-slate-100 py-1 px-5 w-fit rounded-full text-slate-600 font-medium text-center">
              In Progress
            </section>
          ) : hiringReqData?.status === "Hold" ? (
            <section className="bg-yellow-100 py-1 px-5 w-fit rounded-full text-yellow-600 font-medium text-center">
              Hold
            </section>
          ) : hiringReqData?.status === "Completed" ? (
            <section className="bg-green-100 py-1 px-5 w-fit rounded-full text-green-600 font-medium text-center">
              Completed
            </section>
          ) : (
            <section className="bg-red-100 py-1 px-5 w-fit rounded-full text-red-600 font-medium text-center">
              Closed
            </section>
          )}
        </section>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-2 gap-5">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <MdOutlineWatchLater className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Experience Required
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {hiringReqData?.yearsOfExperience}
              </p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaGraduationCap className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Eligibility
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {hiringReqData?.eligibility}
              </p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaCode className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">Skills</h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {hiringReqData?.skills}
              </p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaCalendar className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Opened On
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {new Date(hiringReqData?.openedOn).toDateString("en-In")}
              </p>
            </div>
          </div>
          {hiringReqData?.closedOn && (
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <FaCalendar className="h-6 w-6 text-gray-500" />
              </div>
              <div className="ml-3">
                <h3 className="text-[15px] font-medium text-gray-500">
                  Closed On
                </h3>
                <p className="mt-1 text-[16px] text-gray-900">
                  {new Date(hiringReqData?.closedOn).toDateString("en-In")}
                </p>
              </div>
            </div>
          )}
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaUser className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">Manager</h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {hiringReqData?.userManagerName ||
                  hiringReqData?.companySuperadminName}
              </p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaCheckCircle className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Expected Joining
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {hiringReqData?.expectedJoiningDuration}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 space-y-5">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <FaSuitcase className="h-6 w-6 text-gray-500" />
            </div>
            <div className="ml-3">
              <h3 className="text-[15px] font-medium text-gray-500">
                Job Description
              </h3>
              <p className="mt-1 text-[16px] text-gray-900">
                {hiringReqData?.jobDescription}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function TASingleHiringReq() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.talentAquisation === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const { reqId } = useParams();
  const [hiringReqData, setHiringReqData] = useState(undefined);
  const [file, setFile] = useState(null);
  const fileRef = useRef(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [applicationSource, setApplicationSource] = useState("");
  const [referrerId, setReferrerId] = useState("");
  const [firstScreeningDesc, setFirstScreeningDesc] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reload, setReload] = useState(false);
  const [applicantData, setApplicantData] = useState([]);

  // fetch single hiring request
  async function getHiringReq() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hiring/request/get/single/request/${reqId}`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data);
      setHiringReqData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Hiring request fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // fetch applicants
  async function getApplicants() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisition/job/applicant/get/all/applicant/${page}?hiringReqId=${reqId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTotalPages(res.data?.data?.totalPages || 0);
      setApplicantData(res.data?.data?.data || []);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Applicants fetch failed");
    } finally {
      setLoading(false);
    }
  }

  const applicationSourceArray = [
    {
      title: "Career Page",
      value: "Career Page",
    },
    {
      title: "LinkedIn",
      value: "LinkedIn",
    },
    {
      title: "Naukri",
      value: "Naukri",
    },
    {
      title: "Employee Referrel",
      value: "Employee Referrel",
    },
  ];

  async function addApplicant() {
    if (file === null) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please upload resume");
      return;
    }
    if (applicationSource === "Employee Referrel" && referrerId === "") {
      setOpen(true);
      setSuccess(false);
      setMessage("Please enter employee ID");
      return;
    }
    if (
      name === "" ||
      phone === "" ||
      email === "" ||
      firstScreeningDesc === ""
    ) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please fill all the fields");
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("name", name);
      formData.append("phone", phone);
      formData.append("email", email);
      formData.append("note", note);
      formData.append("applicationSource", applicationSource);
      formData.append("referrerId", referrerId);
      formData.append("firstScreeningDesc", firstScreeningDesc);
      formData.append("resume", file);
      formData.append("hiringReqId", reqId);
      formData.append("managerId", hiringReqData?.userManagerId);
      formData.append("managerModel", hiringReqData?.managerModel);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/talent/aquisition/job/applicant/add`,
        method: "post",
        data: formData,
        withCredentials: true,
      });
      console.log(res.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Applicant added successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Applicant add failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getHiringReq();
  }, [reqId]);

  useEffect(() => {
    getApplicants();
  }, [reload, page, reqId]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Job Details
          </h1>
          <div className="w-full mt-5">
            <HiringReqData hiringReqData={hiringReqData} />
            <div className=" rounded-lg shadow-lg mt-5">
              <div className="flex bg-blue-50/80 rounded-t-lg justify-between items-center p-5">
                <section>
                  <h1 className="text-[25px] font-medium text-left w-full">
                    Applicants
                  </h1>
                </section>
                <section>
                  <DialogBox
                    trigger={
                      <ButtonCompo
                        variant={"contained"}
                        startIcon={<FaUserPlus />}
                      >
                        Add Applicant
                      </ButtonCompo>
                    }
                    actionButton={
                      <ButtonCompo onClick={addApplicant}>Submit</ButtonCompo>
                    }
                    title={"Add Applicant"}
                    maxWidth={"sm"}
                  >
                    <div className="w-full space-y-5">
                      <input
                        type="file"
                        onChange={(eve) => setFile(eve.target.files[0])}
                        className="hidden"
                        ref={fileRef}
                      />
                      <InputField
                        value={name}
                        onChange={(eve) => setName(eve?.target?.value)}
                        label="Name"
                        required
                      />
                      <InputField
                        value={phone}
                        onChange={(eve) => setPhone(eve?.target?.value)}
                        label="Phone Number"
                        required
                      />
                      <InputField
                        value={email}
                        onChange={(eve) => setEmail(eve?.target?.value)}
                        label="Email ID"
                        required
                      />
                      <InputField
                        value={firstScreeningDesc}
                        onChange={(eve) =>
                          setFirstScreeningDesc(eve?.target?.value)
                        }
                        label="First Round Title"
                        required
                      />
                      <section
                        onClick={() => fileRef.current.click()}
                        className="bg-slate-100/10 py-5 flex justify-center px-3 border-dotted items-center w-full border border-blue-500 rounded-[5px] cursor-pointer"
                      >
                        <IoDocumentText className="text-[22px] mr-2 text-blue-600" />
                        <p className="text-blue-600 text-[16px] flex flex-col justify-center items-center gap-1 font-medium">
                          Upload Resume *
                          {file !== null && (
                            <span className="text-slate-500">
                              1 document selected
                            </span>
                          )}
                        </p>
                      </section>
                      <SelectField
                        label={"Application Source"}
                        value={applicationSource}
                        valueArray={applicationSourceArray}
                        setValue={(eve) =>
                          setApplicationSource(eve?.target?.value)
                        }
                      />
                      {applicationSource === "Employee Referrel" && (
                        <InputField
                          label="Employee ID"
                          value={referrerId}
                          required
                          onChange={(eve) => setReferrerId(eve?.target?.value)}
                        />
                      )}
                      <InputField
                        value={note}
                        onChange={(eve) => setNote(eve?.target?.value)}
                        label="Note"
                        multiline
                        rows={7}
                      />
                    </div>
                  </DialogBox>
                </section>
              </div>
              <div className="p-0">
                <div>
                  {applicantData?.length === 0 ? (
                    <div>
                      <p className="mt-0 text-slate-500 text-center p-7 font-semibold">
                        No applicant added yet
                      </p>
                    </div>
                  ) : (
                    <div className="w-full mt-0">
                      <Table>
                        <TableHead>
                          <TableRow className="bg-blue-50/80">
                            <TableCell className="!text-center">
                              SL No
                            </TableCell>
                            <TableCell className="!text-center">
                              Applicant Name
                            </TableCell>
                            <TableCell className="!text-center">
                              Phone Number
                            </TableCell>
                            <TableCell className="!text-center">
                              Email ID
                            </TableCell>
                            <TableCell className="!text-center">
                              Current Round
                            </TableCell>
                            <TableCell className="!text-center">
                              Status
                            </TableCell>
                            <TableCell className="!text-center">
                              Uploaded At
                            </TableCell>
                            <TableCell className="!text-center">
                              Details
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {applicantData.map((item, index) => (
                            <TableRow key={item?._id}>
                              <TableCell className="!text-center">
                                {index + 1}
                              </TableCell>
                              <TableCell className="!text-center">
                                {item?.fullName}
                              </TableCell>
                              <TableCell className="!text-center">
                                {item?.phone}
                              </TableCell>
                              <TableCell className="!text-center">
                                {item?.email}
                              </TableCell>
                              <TableCell className="!text-center">
                                {item?.currentScreeningRound?.desc}
                              </TableCell>
                              <TableCell className="!text-center">
                                {item?.finalStatus}
                              </TableCell>
                              <TableCell className="!text-center">
                                {new Date(item?.createdAt).toLocaleDateString(
                                  "en-In"
                                )}
                              </TableCell>
                              <TableCell className="!text-center">
                                <ButtonCompo
                                  onClick={() =>
                                    navigate(
                                      `/admin/talent/aquisation/single/job/applicant/${item?._id}`
                                    )
                                  }
                                  variant={"outlined"}
                                >
                                  View
                                </ButtonCompo>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <PaginationBar
                        attendancePage={page}
                        setAttendancePage={setPage}
                        totalAttendancePage={totalPages}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TASingleHiringReq;
